<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="序号" width="80" align="center">
				  <template slot-scope="scope">
					{{ (queryForm.page - 1) * queryForm.limit + scope.$index + 1 }}
				  </template>
				</el-table-column>
				<el-table-column label="编码" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.bn }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="产品名称" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.name }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="类型" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.cate_name }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="单价" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.price }}
				  </template>
				</el-table-column>
				<el-table-column label="金额" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.money }}
				  </template>
				</el-table-column>
				<el-table-column label="状态" min-width="70" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.status === 1" size="mini" type="success">正常</el-tag>
					<el-tag v-if="scope.row.status === 2" size="mini" type="danger">已取消</el-tag>
				  </template>
				</el-table-column>
				<el-table-column label="支付状态" min-width="70" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.pay_status === 1" size="mini" type="warning">未付款</el-tag>
					<el-tag v-if="scope.row.pay_status === 2" size="mini" type="success">已付款</el-tag>
					<el-tag v-if="scope.row.pay_status === 3" size="mini" type="warning">预付款</el-tag>
					<el-tag v-if="scope.row.pay_status === 4" size="mini" type="warning">分期付款</el-tag>
					<el-tag v-if="scope.row.pay_status === 5" size="mini" type="warning">押金</el-tag>
					<el-tag v-if="scope.row.pay_status === 6" size="mini" type="danger">已退款</el-tag>
				  </template>
				</el-table-column>
				<el-table-column label="发货状态" min-width="70" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.fh_status === 1" size="mini" type="warning">未发货</el-tag>
					<el-tag v-if="scope.row.fh_status === 2" size="mini" type="success">已发货</el-tag>
				  </template>
				</el-table-column>
				<el-table-column align="center" prop="utime" label="时间" min-width="170">
				  <template slot-scope="scope">
					<i class="el-icon-time" />
					<span>{{ scope.row.ctime }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="操作" min-width="100" align="center" fixed="right">
				  <template slot-scope="scope">
					<el-tooltip class="item" effect="dark" content="编辑" placement="top">
					  <el-button type="success" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>		
		            </el-tooltip>
					<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip>
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
		},
		data() {
			return {
				preUrl: 'kc_xsgl',
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
			}
		},
		mounted() {
			
		},
		methods:{
			handleAdd(){
				this.$router.push({
				  path:"/xsgl_edit",
				  query: {}
				})
			},
           handleEdit(row) {
           	this.$router.push({
           	  path:"/xsgl_edit",
           	  query: {
           		  info:JSON.parse(JSON.stringify(row))
           	  }
           	})
           },
           handleView(row){
           	this.$router.push({
           	  path:"/xsgl_edit",
           	  query: {
           		  id:row.id
           	  }
           	})
           },
		}
	}
</script>

<style>
</style>